import { render, staticRenderFns } from "./BroadcastCompare.vue?vue&type=template&id=63ba1f06&scoped=true&"
import script from "./BroadcastCompare.vue?vue&type=script&lang=js&"
export * from "./BroadcastCompare.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastCompare.vue?vue&type=style&index=0&id=63ba1f06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba1f06",
  null
  
)

export default component.exports